import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';

import { IncidentFormsService } from './incident-forms.service';
@Component({
  selector: 'app-incident-forms',
  templateUrl: './incident-forms.component.html',
  styleUrls: ['./incident-forms.component.scss']
})
export class IncidentFormsComponent implements OnInit {

  incidentForms: any;
  directoryList = false;
  constructor(
    private _incidentService: IncidentFormsService,
    private _router: Router
  ) { }

  ngOnInit() {

    this._incidentService.getIncidentForms()
      .subscribe(
        res => {
          console.log(res);
          this.incidentForms = res['data'];
        },
        err => {
          console.log(err);
        }
      )
  }

  getIncidents(template) {
    console.log(template);
    this._router.navigateByUrl('/incidents/' + template._id);
  }

  getFirstLetterString(name) {
    let result = '';
    let splitArray = name.split(' ');
    if (name.length === 1) {
      result = name;
    } else if (splitArray.length === 1) {
      result = splitArray[0][0] + splitArray[0][1];
    } else {
      _.forEach(splitArray, function (word) {
        result = result.concat(word[0]);
      });
    }

    return result.substring(0, 2);
  }

  getBase64String(str) {
    return 'data:image/jpg;base64,' + str;
  }

  navigateInspection(id) {
    this._router.navigateByUrl('/formFilling/' + id + '?currentPage=incidentForms');
  }

  getIncidentButtonLabel(formId): string {
      if (formId === 'fh_task_template:incidentform') {
          return 'Report an Incident';
      } else if (formId === 'fh_task_template:resolveform') {
          return 'Resolve Incident';
      } else if (formId === 'fh_task_template:rootcauseform') {
          return 'Submit RCA';
      }
      return 'Report an Incident';
  }

}



// WEBPACK FOOTER //
// ./src/app/incident-forms/incident-forms.component.ts